module.exports = __webpack_public_path__ + "static/media/supervip.816d00a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/supervip.png
// module id = 964
// module chunks = 0